import React, { useState } from 'react';
import Icon from 'components/AppIcon';

const SecurityStatus = () => {
  const [showDetails, setShowDetails] = useState(false);

  const securityFeatures = [
    {
      feature: 'End-to-End Encryption',
      status: 'active',
      description: 'AES-256 encryption for all video, audio, and data'
    },
    {
      feature: 'Data Protection Compliance',
      status: 'verified',
      description: 'Compliant with Kenyan Data Protection Act 2019'
    },
    {
      feature: 'Secure Recording',
      status: 'available',
      description: 'Encrypted cloud storage with access controls'
    },
    {
      feature: 'Authentication',
      status: 'verified',
      description: 'Multi-factor authentication for all participants'
    },
    {
      feature: 'Network Security',
      status: 'active',
      description: 'TLS 1.3 secure transport layer'
    }
  ];

  const getStatusColor = (status) => {
    switch (status) {
      case 'active': return 'text-success';
      case 'verified': return 'text-primary';
      case 'available': return 'text-warning-600';
      default: return 'text-text-secondary';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'active': return 'CheckCircle';
      case 'verified': return 'Shield';
      case 'available': return 'Clock';
      default: return 'AlertCircle';
    }
  };

  return (
    <div className="relative">
      <button
        onClick={() => setShowDetails(!showDetails)}
        className="flex items-center space-x-2 px-3 py-2 bg-success-50 hover:bg-success-100 text-success-dark rounded-interactive transition-smooth"
        title="Security Status - Click for details"
      >
        <Icon name="Shield" size={16} />
        <span className="text-sm font-medium">Secure</span>
        <Icon name="ChevronDown" size={12} />
      </button>

      {showDetails && (
        <>
          {/* Overlay to close dropdown */}
          <div
            className="fixed inset-0 z-10"
            onClick={() => setShowDetails(false)}
          />
          
          {/* Security Details Dropdown */}
          <div className="absolute right-0 top-full mt-2 w-80 bg-surface border border-border rounded-lg shadow-dropdown z-20">
            <div className="p-4 border-b border-border">
              <div className="flex items-center space-x-2 mb-2">
                <Icon name="Shield" size={20} className="text-success" />
                <h3 className="font-medium text-text-primary">Security Status</h3>
              </div>
              <p className="text-sm text-text-secondary">
                This consultation is protected by enterprise-grade security measures
              </p>
            </div>

            <div className="p-4 space-y-3">
              {securityFeatures.map((item, index) => (
                <div key={index} className="flex items-start space-x-3">
                  <Icon 
                    name={getStatusIcon(item.status)} 
                    size={16} 
                    className={`flex-shrink-0 mt-0.5 ${getStatusColor(item.status)}`}
                  />
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center justify-between">
                      <p className="text-sm font-medium text-text-primary">
                        {item.feature}
                      </p>
                      <span className={`text-xs font-medium capitalize ${getStatusColor(item.status)}`}>
                        {item.status}
                      </span>
                    </div>
                    <p className="text-xs text-text-secondary mt-1">
                      {item.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <div className="p-4 border-t border-border bg-secondary-50">
              <div className="flex items-center space-x-2 text-xs text-text-secondary">
                <Icon name="Info" size={12} />
                <span>
                  All consultation data is encrypted and stored in accordance with legal confidentiality requirements
                </span>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default SecurityStatus;